import React, { useEffect, useMemo, useState } from "react";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CompDateRangeFields from "components/CompDateRangeFields";

import TextField from "@mui/material/TextField";
import * as XLSX from "xlsx";
import InputLabel from "@mui/material/InputLabel";

import apiDashboard from "services/apiDashboard";
import api from "services/api";

import * as S from "./styles";

import { sortArrayByProperty } from "utils";
import { useForm } from "react-hook-form";
import {
  CircularProgress,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Title from "components/Title";

import AgentCity from "utils/agentCity";
import AgentType from "utils/agentType";
import {
  DescriptionOutlined,
  Download,
  EditOutlined,
  FileDownloadOutlined,
  FormatListBulleted,
} from "@mui/icons-material";
import {
  getCountQueryPath,
  getCountQueryPathById,
  getDesempenhoData,
  getEngajamentoData,
  getSegurancaConformidadeData,
  removeNullObjects,
} from "utils/dashboardAgentFunctions";
import SegurancaConformidadeGraphic from "./SegurancaConformidade";
import EngajamentoAgentesGraphic from "./EngajamentoAgentes";
import DesempenhoGraphic from "./Desempenho";
import ProdutividadeGraphic from "./Produtividade";
import { LoadingButton } from "@mui/lab";

const shortcutsItems = [
  {
    label: "Último dia útil",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(1, "day"), today];
    },
    onClick: () => {
      console.log("clickou");
    },
  },
  {
    label: "Últimos 6 meses",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(6, "month"), today];
    },
  },
  { label: "Limpar", getValue: () => [null, null] },
];

const AgenteMetricsDashboardPage = () => {
  const [cityValue, setCityValue] = useState("Todos");
  const [cityDataValue, setCityDataValue] = useState({
    name: "Todos",
    value: "Todos",
    code: "Todos",
  });

  const [tableData, setTableData] = useState([
    {
      name: "Listagens",
      benefits: 0,
      irregularBenefits: 0,
      agents: 0,
    },
    {
      name: "Edições",
      benefits: 0,
      irregularBenefits: 0,
      agents: 0,
    },
    {
      name: "Criações",
      benefits: 0,
      irregularBenefits: 0,
      agents: 0,
    },
    {
      name: "Downloads",
      benefits: 0,
      irregularBenefits: 0,
      agents: 0,
    },
  ]);
  const [agentesAtivosCount, setAgentesAtivosCount] = useState(0);
  const [agentesExpiradosCount, setAgentesExpiradosCount] = useState(0);
  const [agentesInativosCount, setAgentesInativosCount] = useState(0);
  const [agentesAutorizadosCount, setAgentesAutorizadosCount] = useState(0);
  const [taxaErrosCount, setTaxaErrosCount] = useState(0);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoadingFixedData, setIsLoadingFixedData] = useState(false);

  const [downloadDataGrouped, setDownloadDataGrouped] = useState({
    listagens: [],
    criacoes: [],
    edicoes: [],
    downloads: [],
  });
  const [isLoadingTableDataBtnDownload, setIsLoadingTableDataBtnDownload] =
    useState(false);

  const [engajamentoGraphicData, setEngajamentoGraphicData] = useState({
    xaxis: {
      categories: [],
    },
    series: [
      {
        name: "Taxa de retenção",
        data: [],
      },
    ],
  });

  const [
    segurancaConformidadeGraphicData,
    setSegurancaConformidadeGraphicData,
  ] = useState({
    xaxis: {
      categories: [],
    },
    series: [
      {
        name: "Solicitações de redefinição de senha",
        data: [],
      },
    ],
  });

  const [desempenhoData, setDesempenhoData] = useState({
    xaxis: {
      categories: ["Listagens", "Edições", "Criações", "Downloads"],
    },
    series: [
      {
        name: "Tempo de resposta do sistema em segundos",
        data: [],
      },
    ],
  });

  const [totaisGerais, setTotaisGerais] = useState({
    listagemTotal: 0,
    edicoesTotal: 0,
    criacoesTotal: 0,
    downloadsTotal: 0,
  });

  const [produtividadeData, setProdutividadeData] = useState({
    criacao: 0,
    edicao: 0,
    ativacao: 0,
  });

  const [dateValue, setDateValue] = useState([null, null]);
  const [dateValueLastDay, setDateValueLastDay] = useState([null, null]);
  const [cadUnicoVersion, setCadUnicoVersion] = useState("");

  const [citiesData, setCitiesData] = useState([]);

  const agent_type = AgentType();
  const agent_city = AgentCity();

  useEffect(() => {
    if (["2", "3"].includes(agent_type)) {
      setValue("city", agent_city);
    }
  }, [agent_type]);

  const getCities = async () => {
    try {
      // let { data } = await apiDashboard.get("api/v1/municipios/");
      let { data: cities } = await api.get("/storage/city/all/");
      cities = cities.results;
      cities = sortArrayByProperty(cities, "name");

      setCitiesData(cities);
    } catch (err) {
      console.error(err);
    }
  };

  const getFixedAgents = async () => {
    setIsLoadingFixedData(true);
    try {
      let queryAgentesAutorizados = `controller/agents/?a_status=1&access_expiration_date_after=${dayjs().format(
        "YYYY-MM-DD"
      )}`;
      // #917: "ativos" = cadastro ativo com acesso vigente (igual a
      // "autorizados"); ativo com acesso vencido vai para o proprio cartao,
      // pois vencer o acesso nao muda o a_status.
      let queryAgentesExpirados = `controller/agents/?a_status=1&access_expiration_date_before=${dayjs()
        .subtract(1, "day")
        .format("YYYY-MM-DD")}`;
      let queryAgentesInativos = "controller/agents/?a_status=0";

      if (cityValue !== "Todos") {
        queryAgentesAutorizados =
          queryAgentesAutorizados + `&city=${cityDataValue.code}`;

        queryAgentesExpirados =
          queryAgentesExpirados + `&city=${cityDataValue.code}`;

        queryAgentesInativos =
          queryAgentesInativos + `&city=${cityDataValue.code}`;
      }

      const { data: query_agentes_autorizados } = await api.get(
        queryAgentesAutorizados
      );

      const { data: query_agentes_expirados } = await api.get(
        queryAgentesExpirados
      );

      const { data: query_agentes_inativos } = await api.get(
        queryAgentesInativos
      );

      setAgentesAutorizadosCount(query_agentes_autorizados.count);
      setAgentesAtivosCount(query_agentes_autorizados.count);
      setAgentesExpiradosCount(query_agentes_expirados.count);
      setAgentesInativosCount(query_agentes_inativos.count);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingFixedData(false);
    }
  };

  const getAgents = async (signal) => {
    setIsLoadingData(true);
    try {
      let [startDate, endDate] = dateValue;

      //mudar pra pegar cidade pelo ibge:
      let queryEngajamento = "agent_stats/?";

      let queryTaxaErros = "agent_stats/system/?status_code=500";
      let querySegurancaConformidade =
        "agent_stats/system/?path=/controller/auth/forgot_password/";

      let queryListagensBeneficiarios =
        "agent_stats/system/?method=GET&path=/benefits/";
      let queryListagensBeneficiariosIrregulares =
        "agent_stats/system/?method=GET&path=/benefits/irregular/";
      let queryListagensAgentes =
        "agent_stats/system/?method=GET&path=/controller/agents/";

      let queryCriacoesBeneficiarios =
        "agent_stats/system/?method=POST&path=/benefits/";
      let queryCriacoesAgentes =
        "agent_stats/system/?method=POST&path=/controller/auth/register/";

      let queryEdicoesBeneficiarios =
        "agent_stats/system/?method=PATCH&path_search=/benefits/";

      let queryEdicoesAgentes =
        "agent_stats/system/?method=PATCH&path_search=/controller/agents/";

      let queryDownloadsBeneficiarios =
        "agent_stats/system/?method=GET&path=/storage/reports/";
      let queryDownloadsBeneficiariosIrregulares =
        "agent_stats/system/?method=GET&path=/storage/reports/irregular/";

      if (startDate) {
        queryTaxaErros =
          queryTaxaErros + `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryListagensBeneficiarios =
          queryListagensBeneficiarios +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryListagensBeneficiariosIrregulares =
          queryListagensBeneficiariosIrregulares +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryListagensAgentes =
          queryListagensAgentes +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryCriacoesBeneficiarios =
          queryCriacoesBeneficiarios +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryCriacoesAgentes =
          queryCriacoesAgentes +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryEdicoesBeneficiarios =
          queryEdicoesBeneficiarios +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryEdicoesAgentes =
          queryEdicoesAgentes + `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryDownloadsBeneficiarios =
          queryDownloadsBeneficiarios +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;

        queryDownloadsBeneficiariosIrregulares =
          queryDownloadsBeneficiariosIrregulares +
          `&start_date=${startDate.format("YYYY-MM-DD")}`;
      }

      if (endDate) {
        queryTaxaErros =
          queryTaxaErros + `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryListagensBeneficiarios =
          queryListagensBeneficiarios +
          `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryListagensBeneficiariosIrregulares =
          queryListagensBeneficiariosIrregulares +
          `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryListagensAgentes =
          queryListagensAgentes + `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryCriacoesBeneficiarios =
          queryCriacoesBeneficiarios +
          `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryCriacoesAgentes =
          queryCriacoesAgentes + `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryEdicoesBeneficiarios =
          queryEdicoesBeneficiarios +
          `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryEdicoesAgentes =
          queryEdicoesAgentes + `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryDownloadsBeneficiarios =
          queryDownloadsBeneficiarios +
          `&end_date=${endDate.format("YYYY-MM-DD")}`;

        queryDownloadsBeneficiariosIrregulares =
          queryDownloadsBeneficiariosIrregulares +
          `&end_date=${endDate.format("YYYY-MM-DD")}`;
      }

      if (cityValue !== "Todos") {
        queryEngajamento = queryEngajamento + `&city=${cityDataValue.code}`;

        queryTaxaErros = queryTaxaErros + `&city=${cityDataValue.code}`;

        queryListagensBeneficiarios =
          queryListagensBeneficiarios + `&city=${cityDataValue.code}`;

        queryListagensBeneficiariosIrregulares =
          queryListagensBeneficiariosIrregulares +
          `&city=${cityDataValue.code}`;

        queryListagensAgentes =
          queryListagensAgentes + `&city=${cityDataValue.code}`;

        queryCriacoesBeneficiarios =
          queryCriacoesBeneficiarios + `&city=${cityDataValue.code}`;

        queryCriacoesAgentes =
          queryCriacoesAgentes + `&city=${cityDataValue.code}`;

        queryEdicoesBeneficiarios =
          queryEdicoesBeneficiarios + `&city=${cityDataValue.code}`;

        queryEdicoesAgentes =
          queryEdicoesAgentes + `&city=${cityDataValue.code}`;

        queryDownloadsBeneficiarios =
          queryDownloadsBeneficiarios + `&city=${cityDataValue.code}`;

        queryDownloadsBeneficiariosIrregulares =
          queryDownloadsBeneficiariosIrregulares +
          `&city=${cityDataValue.code}`;
      }

      const resultEngajamento = await getEngajamentoData(
        startDate,
        endDate,
        api,
        queryEngajamento
      );

      const seguranca_conformidade = await getSegurancaConformidadeData(
        startDate,
        endDate,
        api,
        querySegurancaConformidade
      );

      setSegurancaConformidadeGraphicData(seguranca_conformidade);
      setEngajamentoGraphicData(resultEngajamento);

      let { data: criacoesBeneficiarios } = await api.get(
        queryCriacoesBeneficiarios,
        { signal }
      );
      criacoesBeneficiarios = removeNullObjects(criacoesBeneficiarios);

      let { data: criacoesAgentes } = await api.get(queryCriacoesAgentes, {
        signal,
      });
      criacoesAgentes = removeNullObjects(criacoesAgentes);

      let { data: listagensBeneficiarios } = await api.get(
        queryListagensBeneficiarios,
        { signal }
      );
      listagensBeneficiarios = removeNullObjects(listagensBeneficiarios);

      let { data: listagensBeneficiariosIrregulares } = await api.get(
        queryListagensBeneficiariosIrregulares,
        { signal }
      );
      listagensBeneficiariosIrregulares = removeNullObjects(
        listagensBeneficiariosIrregulares
      );

      let { data: listagensAgentes } = await api.get(queryListagensAgentes, {
        signal,
      });
      listagensAgentes = removeNullObjects(listagensAgentes);

      const { data: edicoesBeneficiarios } = await api.get(
        queryEdicoesBeneficiarios,
        { signal }
      );
      const { data: edicoesAgentes } = await api.get(queryEdicoesAgentes, {
        signal,
      });

      const benefitsPatchPath = await getCountQueryPathById(
        edicoesBeneficiarios,
        2
      );
      const agentsPatchPath = await getCountQueryPathById(edicoesAgentes, 3);
      const edicoesBeneficiariosAtivacao = await getCountQueryPath(
        edicoesBeneficiarios,
        "/activate_or_cancel/"
      );

      let { data: downloadsBeneficiarios } = await api.get(
        queryDownloadsBeneficiarios,
        { signal }
      );
      downloadsBeneficiarios = removeNullObjects(downloadsBeneficiarios);

      let { data: downloadsBeneficiariosIrregulares } = await api.get(
        queryDownloadsBeneficiariosIrregulares,
        { signal }
      );
      downloadsBeneficiariosIrregulares = removeNullObjects(
        downloadsBeneficiariosIrregulares
      );

      let { data: taxa_erros } = await api.get(queryTaxaErros, { signal });
      setTaxaErrosCount(taxa_erros?.length);

      setTotaisGerais({
        listagemTotal:
          listagensBeneficiarios.length +
          listagensBeneficiariosIrregulares.length +
          listagensAgentes.length,
        // junta com ativação aqui?
        edicoesTotal:
          benefitsPatchPath.length +
          agentsPatchPath.length +
          edicoesBeneficiariosAtivacao.length,
        criacoesTotal: criacoesBeneficiarios.length + criacoesAgentes.length,
        downloadsTotal:
          downloadsBeneficiarios.length +
          downloadsBeneficiariosIrregulares.length,
      });

      setProdutividadeData({
        criacao: criacoesBeneficiarios.length,
        // apenas beneficiarios ou inclue agentes?
        edicao: benefitsPatchPath.length + agentsPatchPath.length,
        ativacao: edicoesBeneficiariosAtivacao.length,
      });

      const desempenho = getDesempenhoData({
        listagens: [
          listagensBeneficiarios,
          listagensBeneficiariosIrregulares,
          listagensAgentes,
        ],
        edicoes: [
          benefitsPatchPath,
          agentsPatchPath,
          edicoesBeneficiariosAtivacao,
        ],
        criacoes: [criacoesBeneficiarios, criacoesAgentes],
        downloads: [downloadsBeneficiarios, downloadsBeneficiariosIrregulares],
      });

      setDesempenhoData(desempenho);

      let listagensData = [
        ...listagensBeneficiarios,
        ...listagensBeneficiariosIrregulares,
        ...listagensAgentes,
      ];
      let edicoesData = [...benefitsPatchPath, ...agentsPatchPath];
      let criacoesData = [...criacoesBeneficiarios, ...criacoesAgentes];

      let downloadsData = [
        ...downloadsBeneficiarios,
        ...downloadsBeneficiariosIrregulares,
      ];

      setDownloadDataGrouped({
        listagens: listagensData,
        criacoes: criacoesData,
        edicoes: edicoesData,
        downloads: downloadsData,
      });

      const tableData = [
        {
          name: "Listagens",
          benefits: listagensBeneficiarios.length,
          irregularBenefits: listagensBeneficiariosIrregulares.length,
          agents: listagensAgentes.length,
        },
        {
          name: "Edições",
          benefits: benefitsPatchPath.length,
          irregularBenefits: "-",
          agents: agentsPatchPath.length,
        },
        {
          name: "Criações",
          benefits: criacoesBeneficiarios.length,
          irregularBenefits: "-",
          agents: criacoesAgentes.length,
        },
        {
          name: "Downloads",
          benefits: downloadsBeneficiarios.length,
          irregularBenefits: downloadsBeneficiariosIrregulares.length,
          agents: "-",
        },
      ];

      setTableData(tableData);
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Requisição cancelada");
      } else {
        console.error(err);
      }
    } finally {
      setIsLoadingData(false);
    }
  };

  const downloadTable = () => {
    setIsLoadingTableDataBtnDownload(true);
  
    const processData = (data, type) => {
      const groupedData = {};
      data.forEach(({ agent_name, city_name }) => {
        const agent = agent_name || "Agente não identificado";
        const city = city_name || "Cidade não identificada";
        const key = `${agent}||${city}`;
  
        if (!groupedData[key]) {
          groupedData[key] = {
            Agente: agent,
            Cidade: city,
            Listagens: 0,
            Criações: 0,
            Edições: 0,
            Downloads: 0,
          };
        }
  
        groupedData[key][
          {
            listagens: "Listagens",
            criacoes: "Criações",
            edicoes: "Edições",
            downloads: "Downloads",
          }[type]
        ]++;
      });
  
      return groupedData;
    };

  const listagensGrouped = processData(downloadDataGrouped.listagens, "listagens");
  const criacoesGrouped = processData(downloadDataGrouped.criacoes, "criacoes");
  const edicoesGrouped = processData(downloadDataGrouped.edicoes, "edicoes");
  const downloadsGrouped = processData(downloadDataGrouped.downloads, "downloads");

  const mergedData = {};

    [listagensGrouped, criacoesGrouped, edicoesGrouped, downloadsGrouped].forEach((group) => {
      Object.keys(group).forEach((key) => {
        if (!mergedData[key]) {
          mergedData[key] = { ...group[key] };
        } else {
          mergedData[key].Listagens += group[key].Listagens || 0;
          mergedData[key].Criações += group[key].Criações || 0;
          mergedData[key].Edições += group[key].Edições || 0;
          mergedData[key].Downloads += group[key].Downloads || 0;
        }
      });
    });
    
    const sortedData = Object.values(mergedData).sort((a, b) =>
      a.Agente.localeCompare(b.Agente)
    );
      
    const dataToExport = Object.values(mergedData);

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dados dos Agentes");

    XLSX.writeFile(workbook, "dados-agentes.xlsx");

    setIsLoadingTableDataBtnDownload(false);
  };

  const handleDateValueChange = (newValue, ctx) => {
    setDateValue(newValue);

    if (ctx.shortcut && ctx.shortcut.label === "Último dia útil") {
      console.log("dateValueLastDay", dateValueLastDay);
      setDateValue(dateValueLastDay);
    }
  };

  const getLastDayValue = async () => {
    try {
      const { data } = await apiDashboard.get("api/v1/municipios/last_day");
      let apiData = data;

      if (apiData.length > 0) {
        let registration_date = apiData.flat()[0]?.data[0]?.registration_date;
        const lastDay = dayjs(registration_date);
        console.log(registration_date, lastDay);
        setDateValueLastDay([lastDay, lastDay]);
        setDateValue([lastDay, lastDay]);
        let ref_cad = apiData.flat()[0]?.data[0]?.ref_cad;
        setCadUnicoVersion(ref_cad);
      }
    } catch (err) {
      // const today = dayjs();
      // setDateValue([today.subtract(1, "day"), today]);
      console.error(err);
    }
  };

  useEffect(() => {
    getCities();
    getLastDayValue();
    getFixedAgents();
    // getAgents();
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    getFixedAgents();
    getAgents(signal);

    return () => {
      controller.abort();
    };
  }, [dateValue, cityValue]);

  const { register, setValue } = useForm({
    defaultValues: useMemo(() => {
      return {
        city: "Todos",
      };
    }, []),
  });

  const { onChange: onChangeCity } = register("city");

  return (
    <S.CompareDataContainer>
      <S.AllDataWrapper>
        <S.CruzamentoHeaderTexts>
          <Title
            titleText="Painel de gestão de agentes e desempenho do sistema"
            subtitleTexts={[]}
            showCadVersion={false}
            className="title"
          />

          <p className="subtitle">
            Acompanhe aqui o desempenho e as principais métricas de acesso, uso,
            produtividade e segurança.
          </p>

          {cadUnicoVersion && (
            <span>
              Versão do CadÚnico:{" "}
              {cadUnicoVersion?.split("-").reverse().join("/")}
            </span>
          )}
        </S.CruzamentoHeaderTexts>
        <div style={{ display: "flex", gap: 32 }} className="firstRow">
          <S.DateCalendarContainer>
            <InputLabel>Período</InputLabel>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              {/* <DateRangeCalendar
                calendars={1}
                value={dateValue}
                onChange={(newValue) => setDateValue(newValue)}
              /> */}
              <CompDateRangeFields
                value={dateValue}
                onChange={handleDateValueChange}
                shortcuts={shortcutsItems}
                disableFuture
              />
            </LocalizationProvider>
          </S.DateCalendarContainer>

          <S.TextFieldCityContainer>
            <InputLabel>Município</InputLabel>
            <TextField
              select
              id="outlined-select-type"
              margin="normal"
              fullWidth
              required
              placeholder="Digite o indicador"
              disabled={["2", "3"].includes(agent_type)}
              value={["2", "3"].includes(agent_type) ? agent_city : cityValue}
              defaultValue="Todos"
              InputLabelProps={{ shrink: true }}
              {...register("city")}
              onChange={(event) => {
                onChangeCity(event);
                const {
                  target: { value },
                } = event;
                setCityDataValue(
                  value !== "Todos"
                    ? citiesData.find((city) => city.name === value)
                    : { name: "Todos", value: "Todos", code: "Todos" }
                );
                setCityValue(value);
              }}
            >
              {[
                { name: "Todos", value: "Todos", code: "Todos" },
                ...citiesData,
              ].map((item) => (
                <MenuItem key={item.id} value={item.name}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </S.TextFieldCityContainer>
        </div>

        <S.FirstCardsContainer>
          <div className="card">
            <p className="title">
              Total de agentes autorizados
              <p className="value">
                {isLoadingFixedData ? (
                  <CircularProgress
                    style={{ color: "#F9922A" }}
                    thickness={5}
                  />
                ) : (
                  agentesAutorizadosCount
                )}
              </p>
            </p>
          </div>
          <div className="card">
            <p className="title">
              Agentes ativos
              <p className="value">
                {isLoadingFixedData ? (
                  <CircularProgress
                    style={{ color: "#F9922A" }}
                    thickness={5}
                  />
                ) : (
                  agentesAtivosCount
                )}
              </p>
            </p>
          </div>
          <div className="card">
            <p className="title">
              Agentes com acesso expirado
              <p className="value">
                {isLoadingFixedData ? (
                  <CircularProgress
                    style={{ color: "#F9922A" }}
                    thickness={5}
                  />
                ) : (
                  agentesExpiradosCount
                )}
              </p>
            </p>
          </div>
          <div className="card">
            <p className="title">
              Agentes inativos
              <p className="value">
                {isLoadingFixedData ? (
                  <CircularProgress
                    style={{ color: "#F9922A" }}
                    thickness={5}
                  />
                ) : (
                  agentesInativosCount
                )}
              </p>
            </p>
          </div>
          <div className="card">
            <p className="title">
              Taxa de erros
              <p className="value">
                {isLoadingData ? (
                  <CircularProgress
                    style={{ color: "#F9922A" }}
                    thickness={5}
                  />
                ) : (
                  taxaErrosCount
                )}
              </p>
            </p>
          </div>
        </S.FirstCardsContainer>

        <S.SystemUsageContainer>
          <h4 className="title">Uso do sistema</h4>
          <div className="cardsContainer">
            <div className="card">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className="text">Listagem</span>
                <span className="value">
                  {isLoadingData ? (
                    <CircularProgress
                      style={{ color: "#F9922A" }}
                      thickness={5}
                    />
                  ) : (
                    totaisGerais.listagemTotal
                  )}
                </span>
              </div>
              <div className="icon">
                <FormatListBulleted />
              </div>
            </div>
            <div className="card">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className="text">Edições</span>
                <span className="value">
                  {isLoadingData ? (
                    <CircularProgress
                      style={{ color: "#F9922A" }}
                      thickness={5}
                    />
                  ) : (
                    totaisGerais.edicoesTotal
                  )}
                </span>
              </div>
              <div className="icon">
                <EditOutlined />
              </div>
            </div>
            <div className="card">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className="text">Criações</span>
                <span className="value">
                  {isLoadingData ? (
                    <CircularProgress
                      style={{ color: "#F9922A" }}
                      thickness={5}
                    />
                  ) : (
                    totaisGerais.criacoesTotal
                  )}
                </span>
              </div>
              <div className="icon">
                <DescriptionOutlined />
              </div>
            </div>
            <div className="card">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className="text">Downloads</span>
                <span className="value">
                  {isLoadingData ? (
                    <CircularProgress
                      style={{ color: "#F9922A" }}
                      thickness={5}
                    />
                  ) : (
                    totaisGerais.downloadsTotal
                  )}
                </span>
              </div>
              <div className="icon">
                <FileDownloadOutlined />
              </div>
            </div>
          </div>

          <div className="tableContainer">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>TIPO DE AÇÃO</TableCell>
                    <TableCell align="left">BENEFÍCIOS</TableCell>
                    <TableCell align="left">BENEFÍCIOS IRREGULARES</TableCell>
                    <TableCell align="left">AGENTES</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoadingData ? (
                    <TableRow>
                      <TableCell colSpan={4} component="th" scope="row">
                        <div className="tableContainerLoading">
                          <CircularProgress
                            style={{ color: "#F9922A" }}
                            thickness={5}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    tableData.map((row, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell align="left">{row.benefits}</TableCell>
                        <TableCell align="left">
                          {row.irregularBenefits}
                        </TableCell>
                        <TableCell align="left">{row.agents}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </S.SystemUsageContainer>

        <div style={{ display: "flex", gap: 20 }}>
          <EngajamentoAgentesGraphic
            isLoadingData={isLoadingData}
            data={engajamentoGraphicData}
          />
          <ProdutividadeGraphic
            isLoadingData={isLoadingData}
            data={[
              produtividadeData.criacao,
              produtividadeData.edicao,
              produtividadeData.ativacao,
            ]}
          />
        </div>
        <div style={{ display: "flex", gap: 20 }}>
          <SegurancaConformidadeGraphic
            isLoadingData={isLoadingData}
            data={segurancaConformidadeGraphicData}
          />
          <DesempenhoGraphic
            isLoadingData={isLoadingData}
            data={desempenhoData}
          />
        </div>

        {!["2","3", "4", "6"].includes(agent_type) && (
        <LoadingButton
          onClick={downloadTable}
          variant="contained"
          loading={isLoadingTableDataBtnDownload}
          loadingPosition="start"
          className="btn-search"
          startIcon={<Download />}
          style={{ float: "right" }}
          sx={{
            background: " var(--Light-Verde---light, #88C54B)",
            width: "180px",
            height: "54px",
            padding: "15px 16px",
            borderRadius: "8px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 300,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#88C54B",
            },
          }}
        >
          Baixar dados
        </LoadingButton>
        )}
      </S.AllDataWrapper>
    </S.CompareDataContainer>
  );
};

export default AgenteMetricsDashboardPage;
